const local = "http://localhost:3001";
const web = "https://axis-global-backend.onrender.com";
const activeBaseUrl = web;

export default activeBaseUrl;